import React, {useMemo} from 'react';
import {tableColumnsWithProps} from './columns';
import CommercialTable from '../../../../../common/components/commercialTable/commercialTable';

export const OrdersInfoTable = ({ordersByDate, setFilters, code, setOpenOrders}) => {
  const columnsTable = tableColumnsWithProps(code, setFilters, setOpenOrders);
  const data = useMemo(() => ordersByDate, [ordersByDate]);
  const columns = useMemo(() => columnsTable, []);

  return (
    <CommercialTable
      columns={columns}
      data={data}
      tableWrapperStyles='priorization-modal-container-table'
      tableType='fixed'
      isSmallCell={true}
      pagination={false}
      lineColor={['']}
    />
  );
};
export default OrdersInfoTable;
